module.exports = __webpack_public_path__ + "static/media/kaliLinux.93022b70.png";